a.greenBtnLink, a.greenWhiteBtnLink {
    /* emerald-500 */
    background-color: rgb(16 185 129) !important;
    /* background-color: var(--green-700); */
    /* emerald-800 */
    border-color: rgb(6 95 70);
    /* border-color: var(--green-800); */
    /* padding */
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    /* font */
    font-size: 1rem;
    /* shadow */
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    text-decoration: none;
}

a.greenBtnLink {
    border-radius: 5px;
    color: black;
}

a.greenWhiteBtnLink {
    color: white;
    border-radius: 10px;
}

a.greenWhiteBtnLink:hover {
    background-color: rgb(5 150 105);
}

a.greenBtnLink:hover {
    /* gray-100 */
    /* background-color: rgb(243 244 246); */
    /* emerald-600 */
    background-color: rgb(5 150 105);
    /* emerald-700 */
    /* background-color: rgb(4 120 87); */
}

.mobileAddPropertyButton {
    display: none
}

/* unlayered CSS beats MUI's layered .Mui-disabled rule, so exclude :disabled here */
.modalSuccessButton:not(:disabled) {
    background-color: rgb(16 185 129);
}

@media screen and (max-width: 800px) {
    .mobileAddPropertyButton {
        display: flex;
        position: fixed;
        bottom: 15px;
        right: 25px;
        border-radius: 50%;
        border: black solid 1px;
        height: 50px;
        width: 50px;
        line-height: 50px;
        font-size: 30px;
        background-color: #28D89D;
        text-decoration: none;
        color: black;
        justify-content: center;
        align-content: center;
    }
}

.greenButtonWhiteText {
    color: white;
}